import ariz235 from './Ariz/Config';
import as1289_5_8_1 from './As/Config';
import bs1377_9_clause_2_5 from './Bs/Config';

export default {
  ...ariz235,
  ...bs1377_9_clause_2_5,
  ...as1289_5_8_1,
};
